import UserFinderInterfaceClass from "../infrastructure/user-finder-interface.js";
import UserFinderValidator from "../domain/user-finder-validator.js";
import UserStoreUtil from "./utils/user-store-util.js";

import StoreInterfaceClass from "../../shared/infrastructure/store-interface";

import AppError from "../../shared/domain/errors/app-error";
import { CustomDate } from "../../shared/domain/classes/custom-date";

export default class {
	constructor() {
		this.backend_interface = new UserFinderInterfaceClass();
		this.store_interface = new StoreInterfaceClass();
		this.validator = UserFinderValidator;
	}

	async get_user(force_download = null) {
		const cached_data = this.get_stored_user();
		if (cached_data && !force_download) return cached_data;

		try {
			const interface_data = await this.backend_interface.get_user();
			const validated_data = this.validator.validate(interface_data);

			UserStoreUtil.set_data(
				validated_data,
				new CustomDate().add(7, "days").to_date()
			);

			return validated_data;
		} catch (e) {
			throw new AppError("error_get_user", null, e);
		}
	}

	get_stored_user() {
		return UserStoreUtil.get_data();
	}
}
